import React from 'react';

import {Icon, Icons} from '@pb/kit-component-icon';
import {Tooltip} from '@pb/kit-component-popups';

import {errorFlatButton, errorFlatButtonTooltip} from './error-flat-button.module.styl';

type Props = {
    text: string,
};

export const WarningIcon = ({text}: Props) => (
    <Tooltip
        color="light"
        anchor={({anchorRef, getAnchorProps}) => (
            <Icon
                ref={anchorRef}
                {...getAnchorProps()}
                className={errorFlatButton}
                type={Icons.ERROR}
            />
        )}>
        <div className={errorFlatButtonTooltip}>
            {text}
        </div>
    </Tooltip>
);
